import { $_GENERIC_LIGHTBOX_ } from '../base/vars.js';
import { isMobileWidth, exists } from '../base/dom-utils.js';
import {
  buildCcrsUrl,
  getSessionStorage,
  setSessionStorage
} from '../base/session-handler.js';

export const ELEGANT_AUTH_GATE_CCRS_URL = 'elegantAuthGateCcrsUrl';
const ELEGANT_AUTH_GATE_LOCATIONS_MOBILE = 'elegantAuthGateLocationsMobile';
const ELEGANT_AUTH_GATE_PENDING_CCRS = 'elegantAuthGatePendingCcrs';

function isLocationsMobileDevice() {
  return exists('.locations-list-view-component') &&
    ($('body').is('.ios,.iphone,.ipad,.ipod,.android') || isMobileWidth());
}

function clearModalBackdrop() {
  $('body').removeClass('modal-open');
  $('.modal-backdrop').remove();
}

function isLocationsMobileAuthGateFlow() {
  if (getSessionStorage(ELEGANT_AUTH_GATE_LOCATIONS_MOBILE)) {
    sessionStorage.removeItem(ELEGANT_AUTH_GATE_LOCATIONS_MOBILE);
    return true;
  }
  return isLocationsMobileDevice();
}

export function openAuthGateCcrsAfterLogin() {
  const ccrsData = getSessionStorage(ELEGANT_AUTH_GATE_CCRS_URL);
  const baseCcrsUrl = ccrsData && ccrsData.url;

  if (!baseCcrsUrl) {
    return false;
  }

  sessionStorage.removeItem(ELEGANT_AUTH_GATE_CCRS_URL);

  if (isLocationsMobileAuthGateFlow()) {
    clearModalBackdrop();
    setSessionStorage(ELEGANT_AUTH_GATE_PENDING_CCRS, { url: baseCcrsUrl });
    return true;
  }

  const url = buildCcrsUrl(baseCcrsUrl, true);
  if (!url) {
    return false;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}

export function redirectToCcrsUrl(baseCcrsUrl) {
  const url = buildCcrsUrl(baseCcrsUrl);
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return true;
  }
  return false;
}

export function bindElegantAuthGateEvents(triggerButton) {
  const ccrsUrl = $(triggerButton).data('ccrs-url') || '';
  const $content = $_GENERIC_LIGHTBOX_.find('.modal-content');

  $content.find('.signin-button').off('click.authGateSignIn').on('click.authGateSignIn', () => {
    if (ccrsUrl) {
      setSessionStorage(ELEGANT_AUTH_GATE_CCRS_URL, { url: ccrsUrl });
      if (isLocationsMobileDevice()) {
        setSessionStorage(ELEGANT_AUTH_GATE_LOCATIONS_MOBILE, true);
      }
    }
  });

  $content.find('#continue-as-guest-link').off('click.authGate').on('click.authGate', (e) => {
    e.preventDefault();
    if (!ccrsUrl) return;
    sessionStorage.removeItem(ELEGANT_AUTH_GATE_CCRS_URL);
    sessionStorage.removeItem(ELEGANT_AUTH_GATE_LOCATIONS_MOBILE);
    sessionStorage.removeItem(ELEGANT_AUTH_GATE_PENDING_CCRS);
    const url = buildCcrsUrl(ccrsUrl);
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    $_GENERIC_LIGHTBOX_.modal('hide');
  });
}
